import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { listVerifiedSchoolSlugs } from "@/lib/school-profiles.functions";

/**
 * Vilka skolor som faktiskt är verifierade, dvs. har tagit över sin profil och
 * publicerat den. Ett enda anrop delas av alla kort via react-querys cache.
 *
 * Offentliga myndighetsuppgifter är INTE verifiering — de finns på alla
 * profiler. Verifiering betyder skolans egen röst.
 */
export function useVerifiedSchools(): Set<string> {
  const fetchSlugs = useServerFn(listVerifiedSchoolSlugs);
  const { data } = useQuery({
    queryKey: ["school_profiles", "verified-slugs"],
    queryFn: async () => {
      try {
        return await fetchSlugs({});
      } catch {
        return [] as string[];
      }
    },
    staleTime: 10 * 60_000,
  });
  return useMemo(() => new Set(data ?? []), [data]);
}
